import React from 'react';

const PiggyBank = () => (
    <svg className="piggy" version="1.1" x="144px" y="144px" viewBox="0 0 144 144">

				<path d="M66.8,39c-3.6,0-6.5-2.9-6.5-6.5c0-3.6,2.8-6.3,6.5-6.3c2.4,0,4.4,1.6,5.4,3.1c0.6,0.9,0.4,2.2-0.5,2.8
					c-0.9,0.6-2.2,0.4-2.8-0.5c-0.6-0.8-1.5-1.4-2.2-1.4c-1.4,0-2.5,0.9-2.5,2.3c0,1.4,1.1,2.5,2.5,2.5c1.1,0,2,0.9,2,2
					S67.9,39,66.8,39z"/>

				<path d="M71.3,43.5c-1.1,0-2-0.9-2-2c0-1.4-1.1-2.5-2.5-2.5c-1.1,0-2-0.9-2-2s0.9-2,2-2c3.6,0,6.5,2.9,6.5,6.5
					C73.3,42.6,72.4,43.5,71.3,43.5z"/>

			<path d="M66.7,30.2c-1,0-1.9-0.7-2-1.8l-0.2-1.9c-0.1-1.1,0.7-2.1,1.7-2.2c1.1-0.1,2.1,0.7,2.2,1.7l0.2,1.9
				c0.1,1.1-0.7,2.1-1.7,2.2C66.9,30.2,66.8,30.2,66.7,30.2z"/>

			<path d="M51.5,44.1c-0.8,0-1.6-0.5-1.9-1.4c-0.6-1.8-0.9-3.7-0.9-5.6c0-9.8,8-17.8,17.8-17.8s17.8,8,17.8,17.8
				c0,1.8-0.3,3.6-0.8,5.3c-0.3,1.1-1.4,1.6-2.5,1.3c-1.1-0.3-1.6-1.4-1.3-2.5c0.4-1.3,0.6-2.7,0.6-4.1c0-7.6-6.2-13.8-13.8-13.8
				c-7.6,0-13.8,6.2-13.8,13.8c0,1.5,0.2,2.9,0.7,4.3c0.3,1-0.2,2.2-1.3,2.5C51.9,44,51.7,44.1,51.5,44.1z"/>

		<path d="M84.1,110.5H48.8c-17.4,0-31.5-14.1-31.5-31.5v-0.7c0-12.5,5.3-24.4,14.6-32.7c0.8-0.7,2.1-0.7,2.8,0.2
			c0.7,0.8,0.7,2.1-0.2,2.8C26,56.1,21.3,66.7,21.3,78.2V79c0,15.2,12.3,27.5,27.5,27.5h35.3c15.2,0,27.5-12.3,27.5-27.5v-0.7
			c0-18.4-12.3-34.4-29.9-38.8c-1.1-0.3-1.7-1.4-1.5-2.4c0.3-1.1,1.4-1.7,2.4-1.5c19.4,4.9,32.9,22.4,32.9,42.7V79
			C115.7,96.3,101.5,110.5,84.1,110.5z"/>

		<path d="M37.2,45.8c-0.6,0-1.2-0.3-1.6-0.8c-0.6-0.9-0.4-2.1,0.5-2.8c4.5-3.2,9.1-5.3,14.2-6.6c1.1-0.3,2.2,0.4,2.4,1.5
			c0.3,1.1-0.4,2.2-1.5,2.4c-4.7,1.2-8.7,3.1-12.8,6C38,45.7,37.6,45.8,37.2,45.8z"/>

		<path d="M34.5,58.2c-1.1,0-2-0.9-2-2v-2.1c0-2.5-0.5-4.9-1.4-7.2L29,42c-0.4-1-0.2-2.1,0.6-2.8c0.8-0.7,1.9-0.9,2.9-0.4l3.1,1.6
			c4.7,2.5,8.3,6.9,9.8,12l-1.9,0.6l-1.9,0.6c-1.2-4-3.8-7.4-7.4-9.4l0.5,1.2c1.2,2.8,1.8,5.7,1.8,8.8v2.1
			C36.5,57.3,35.6,58.2,34.5,58.2z"/>

		<path d="M19.3,86.7c-0.1,0-0.2,0-0.3,0L8.8,85.2c-1-0.1-1.7-1-1.7-2V72.3c0-1,0.7-1.8,1.7-2L19,68.9c1.1-0.2,2.1,0.6,2.3,1.7
			c0.2,1.1-0.6,2.1-1.7,2.3L11,74.1v7.4l8.6,1.2c1.1,0.2,1.9,1.2,1.7,2.3C21.2,85.9,20.3,86.7,19.3,86.7z"/>

		<path d="M82.7,44.8H50.5c-1.1,0-2-0.9-2-2s0.9-2,2-2h32.2c1.1,0,2,0.9,2,2S83.8,44.8,82.7,44.8z"/>

		<path d="M115.8,91.6h-3.9c-1.1,0-2-0.9-2-2s0.9-2,2-2h3.9c2,0,3.9-0.5,5.6-1.5l-1.8-1.8c-1.1-1.2-1.7-2.7-1.5-4.3
			c0.1-1.6,0.9-3.1,2.2-4l0.6-0.5c2.2-1.7,5.3-1.4,7.2,0.6c2.3,2.4,2.4,6,0.4,8.6l-1,1.3c1.2,0.4,2.6,0.4,3.8-0.2l3.8-1.7
			c1-0.5,2.2,0,2.7,1c0.5,1,0,2.2-1,2.7l-3.8,1.7c-2.8,1.3-6,1.1-8.5-0.5C121.9,90.6,119,91.6,115.8,91.6z M124.1,78.3
			c-0.3,0-0.6,0.1-0.8,0.3l-0.6,0.5c-0.4,0.3-0.6,0.7-0.6,1.2c0,0.5,0.1,0.9,0.4,1.3l1.8,1.9l1-1.3c0.8-1,0.7-2.4-0.1-3.3
			C124.9,78.4,124.5,78.3,124.1,78.3z"/>

		<path d="M51.6,120.1H35.8c-0.6,0-1.2-0.3-1.6-0.8c-0.4-0.5-0.5-1.2-0.3-1.8l3.5-11.2c0.3-1.1,1.5-1.6,2.5-1.3
			c1.1,0.3,1.6,1.5,1.3,2.5l-2.7,8.6h11.1v-7.6c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v9.6C53.6,119.2,52.7,120.1,51.6,120.1z"/>

		<path d="M95.7,120.1H79.9c-0.6,0-1.2-0.3-1.6-0.8c-0.4-0.5-0.5-1.2-0.3-1.8l3-9.6c0.3-1.1,1.5-1.6,2.5-1.3
			c1.1,0.3,1.6,1.5,1.3,2.5l-2.2,7h11l-0.3-9.7c0-1.1,0.8-2,1.9-2.1c0,0,0,0,0.1,0c1.1,0,2,0.9,2,1.9l0.3,11.8
			c0,0.5-0.2,1.1-0.6,1.4C96.7,119.8,96.2,120.1,95.7,120.1z"/>

		<path d="M34.2,74.3c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4s5.4,2.4,5.4,5.4C39.6,71.9,37.1,74.3,34.2,74.3z M34.2,67.6
			c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4C35.6,68.2,34.9,67.6,34.2,67.6z"/>

		<path d="M98.4,75.2c-0.9,0-1.7-0.6-1.9-1.5l-1-4.1c-0.3-1-0.5-1.9-0.9-2.6c-3-6.1-8.3-10.9-14.8-13.1c-0.5-0.2-1.1-0.3-1.8-0.4
			l-4.4-0.6c-1.1-0.1-1.9-1.2-1.7-2.2c0.1-1.1,1.2-1.9,2.2-1.7l4.4,0.6c1,0.1,1.8,0.3,2.6,0.6c7.5,2.5,13.7,8.1,17.1,15.2
			c0.5,0.9,0.8,2,1.1,3.3l1,4.1c0.3,1.1-0.4,2.2-1.5,2.4C98.7,75.1,98.6,75.2,98.4,75.2z"/>

</svg>

)

export default PiggyBank;
